export default __webpack_public_path__ + "47d575a6a98b9990cc0ea729dd0d25f4.png";